import React from "react";
import "./MainLayoutStyle.scss";

const MainLayout = ({ className, children }) => {
  return (
    <>
      <main className={`main-layout ${className}`}>
        {children}
      </main>
    </>
  );
};

export default MainLayout;
